import * as React from 'react';

import { StylesPanelProps } from './StylesPanel.types';
import { stylesSort, styleSizes } from './StylesPanel.data';
import { StepsPanel } from '../StepsPanel';
import { Swatch } from '../Swatch';
import './styles/StylesPanel.css';

export const StylesPanel = ({
    option,
    onSelect,
    value,
    step,
    title,
}: StylesPanelProps) => {

    // Set up
    const [ currentVal, setCurrentVal ] = React.useState(value);

    const {
        name,
        values
    } = option;

    React.useEffect(() => {
        setCurrentVal(value);
    }, [value]);

    // Methods
    const sortArray = (
        arr: string[],
        sortArr: string[]
    ): string[] => {
        let sortedVals: any = [];
        sortArr.forEach((key: string) => {
            let found = false;
            (arr as any).filter((val: string) => {
                if(!found && key == val) {
                    sortedVals.push(val);
                    found = true;
                    return false;
                } else {
                    return true;
                }
            });
        });
        return sortedVals;
    };

    const onClickHandler = (
        variantValue: string
    ) => { 
        setCurrentVal(variantValue);
        onSelect({
            name,
            value: variantValue,
            colour: null,
            step: step,
        });
    };

    const getCaption = (value: string) =>
        (styleSizes as any)[value] ? (
            <span>
                {value}
                <br/><small>{(styleSizes as any)[value]}</small>
            </span>
        ) : value;

    const sortedVals = sortArray(values, stylesSort);

    return (
        <StepsPanel 
            className={`options ${name.toLowerCase()}`}
            step={step}
            title={`Choose your ${title}`}
        >
            <div className="swatch-container">
                {sortedVals.map((swatchValue: string, index: number) => (
                    <div
                        key={`OptionPanel${name}Slide${index}`}
                        tabIndex={-2}
                        className="swatch-wrapper"
                    >
                        <Swatch
                            value={swatchValue}
                            selected={currentVal === swatchValue}
                            onClick={() => onClickHandler(swatchValue)}
                            caption={getCaption(swatchValue)}
                        />
                    </div>
                ))}
            </div>
        </StepsPanel>
    );
};
